(function () {
  function init(section) {
    var feature = section.querySelector('.aeya-shop-the-look__feature-img');
    var rows = section.querySelectorAll('.aeya-shop-the-look__link[data-hover-image]');
    if (!feature || !rows.length) return;

    var defaultSrc = feature.getAttribute('data-default-image') || feature.getAttribute('src');
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!canHover) return;

    rows.forEach(function (row) {
      var src = row.getAttribute('data-hover-image');
      if (src) {
        var pre = new Image();
        pre.src = src;
      }
    });

    function swapTo(src) {
      if (!src || feature.getAttribute('src') === src) return;
      feature.classList.add('is-swapping');
      var loader = new Image();
      loader.onload = function () {
        feature.removeAttribute('srcset');
        feature.setAttribute('src', src);
        requestAnimationFrame(function () {
          feature.classList.remove('is-swapping');
        });
      };
      loader.onerror = function () {
        feature.classList.remove('is-swapping');
      };
      loader.src = src;
    }

    rows.forEach(function (row) {
      var hoverSrc = row.getAttribute('data-hover-image');
      row.addEventListener('mouseenter', function () {
        swapTo(hoverSrc);
      });
      row.addEventListener('mouseleave', function () {
        swapTo(defaultSrc);
      });
      row.addEventListener('focus', function () {
        swapTo(hoverSrc);
      });
      row.addEventListener('blur', function () {
        swapTo(defaultSrc);
      });
    });
  }

  function boot() {
    document.querySelectorAll('.aeya-shop-the-look').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
